// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql} from 'react-relay'

const addMutation = graphql`
    mutation MediaFileAddMutation(
    $input: MediaFileAddInput!
    ) {
        MediaFileAdd(input: $input) {
            mediaFileEdge {
                node {
                    id
                }
            }
        }
    }
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, location: ?string) => void) {
    console.log("will mutate")
    commitMutation(
        environment,
        {
            mutation: addMutation,
            variables: {
                input: params
            },
            onCompleted: (response) => {
                
                console.log(response);
                if (response.error !== null && response.error !== undefined) {
                    callback(response.error, null);
                    return
                }
                
                callback(null, response.MediaFileAdd.mediaFileEdge.node.id)
            },
            onError: (error) => {
                console.log("error mutating");
                console.log(error);
                callback(error, null);
            },
        })
}


// WEBPACK FOOTER //
// src/mutations/MediaFileAddMutation.js